import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { Address, Contact, PersonalDetails } from 'components/forms'
import { Checkbox, Input, Select } from 'components/fields'
import { Button, Note, FormDebug, Title } from 'components/misc'
import { wizard, meta } from 'helpers/decorators'
import { apiCodeLists, apiAwardUnits, apiConfiguration, apiCommon } from 'helpers/decorators/api'
import validate from './award-unit-authorising-contact.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { awardUnit } from '../../../../constants/wizards'
import { connect } from 'react-redux'


const asyncValidate = (val, dispatch, props) => {
  const { values } = props

  const licenseHolderAsCoordinator = get(values,'licenseHolderAsCoordinator')

  if ((!get(values, 'email') && (licenseHolderAsCoordinator && !get(values, 'awardLeaderRegistration.email')))) {
    return new Promise(resolve => resolve())
  }

  const email = licenseHolderAsCoordinator ? get(values, 'awardLeaderRegistration.email') : get(values, 'email')
  return props.checkEmail({ email: email }).then(body => {
    if (get(body, 'value')) {
      const err = {
        text:
          'E-mail address is already in use, if you want to register for another level, please sign in to your account.',
        intlKey: 'errors.email_address_is_in_use_please_sign'
      }

      if(licenseHolderAsCoordinator){
        // eslint-disable-next-line
        throw { awardLeaderRegistration: { email: err } }
      }else{
        // eslint-disable-next-line
        throw { email: err }
      }
    }
  })
}

// asyncValidate,
@apiConfiguration()
@apiCommon({
  publicCountries: true
})
@apiCodeLists(['titles', 'phoneTypes', 'genders'], { public: true })
@apiAwardUnits()
@wizard({
  form: 'awardUnitRegistration',
  multipage: true,
  destroyOnUnmount: false,
  validate,
  asyncValidate,
  asyncBlurFields: ['email', 'awardLeaderRegistration.email']
})
@meta({
  title: 'Authorising Contact / License Holder',
  intlKey: 'moduleTitle.authorising_contact_license_holder'
})
@connect(
  state => ({
    config: state.apiV2.configuration
  }),
  null
)
class AwardUnitAuthorisingContact extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object,
    handleGetAwardUnitRegistrationFieldsCustomization: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    config: PropTypes.object,
    common: PropTypes.object.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired,
    handleGetLeaderRegistrationFieldsCustomization: PropTypes.func.isRequired
  };

  componentDidMount = () => {
    const organizationId = this.getOrganizationId(this.props.values.helpers)

    this.props.handleGetAwardUnitRegistrationFieldsCustomization(organizationId, [
      CONFIGURATION_KEYS.leaderMinAge.id,
      CONFIGURATION_KEYS.authContactAsMainCoordinatorIsEnabled.id
    ])
  }

  componentDidUpdate = prevProps => {
    const { steps, rootPath } = awardUnit

    const licenseHolderAsCoordinator = get(this.props, 'values.licenseHolderAsCoordinator')

    if (get(prevProps, 'values.licenseHolderAsCoordinator') !== licenseHolderAsCoordinator) {
      this.props.changeWizardActive(steps.leader.id, !licenseHolderAsCoordinator)
      this.props.changeWizardActive(steps.leaderContact.id, !licenseHolderAsCoordinator)

      if (licenseHolderAsCoordinator) {
        this.props.changeWizardNext(
          steps.authorisingContact.id,
          rootPath + steps.orbAccount.path
        )
      } else {
        this.props.changeWizardNext(
          steps.authorisingContact.id,
          rootPath + steps.leader.path
        )
      }
    }

    if (get(prevProps, 'values.helpers') !== this.props.values.helpers) {
      this.props.handleGetLeaderRegistrationFieldsCustomization(this.getOrganizationId(get(prevProps, 'values.helpers')))
    }

  }

  getOrganizationId = helpers => {
    return get(helpers, 'selectedSoa.id') ||
      get(helpers, 'selectedOa.id') ||
      get(helpers, 'selectedCountry.naoId')
  }

  handleChangeSetAsMainCoordinator = (value) => {
    this.props.change('helpers.licenseHolderAsCoordinator', value)

    if(value){
      this.props.change('awardLeaderRegistration.email', get(this.props.values, 'email'))
      this.props.change('awardLeaderRegistration.emailAgain', get(this.props.values, 'emailAgain'))
      this.props.change('awardLeaderRegistration.phoneType.value', get(this.props.values, 'phoneType.value'))
    } else {
      this.props.change('email', get(this.props.values,'awardLeaderRegistration.email'))
      this.props.change('emailAgain', get(this.props.values,'awardLeaderRegistration.emailAgain'))
      this.props.change('phoneType.value', get(this.props.values,'awardLeaderRegistration.phoneType.value'))
    }
  }

  render() {
    const { handleSubmit, onSubmit, values, errors, codeLists, config, common } = this.props

    const selectedCountryIcoCode = get(values,'helpers.selectedCountry.isoCode')

    const licenseHolderAsCoordinator = get(values,'licenseHolderAsCoordinator')

    const authContactAsMainCoordinatorIsEnabled = get(config,
      `values[${CONFIGURATION_KEYS.authContactAsMainCoordinatorIsEnabled.id}].booleanValue`, false)

    const minAgeCfg = get(config, `values[${CONFIGURATION_KEYS.leaderMinAge.id}].intValue`)

    const showDateOfBirth = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactDateOfBirth.id)

    const showCountry = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCountry.id)

    const showMiddleName = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactMiddleName.id)

    const showGender = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactGender.id)

    const showFirstLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine1.id)

    const showSecondLine = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressLine2.id)

    const showCity = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressCity.id)

    const showZipCode = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressZipCode.id)

    const showRegion = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactAddressRegion.id)

    const showTitle = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactTitle.id)

    const showRole = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactRole.id)

    const showPhone = this.props.isConfigurationTrue(CONFIGURATION_KEYS.organizationContactPhoneNumber.id)

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.authorising_contact_license_holder"
            defaultMessage="Authorising Contact / License Holder"
          />
        </Title>
        <Note margin="-15px 0 30px">
          <FormattedMessage
            id="label.please_fill_in_the_following"
            defaultMessage="Please fill in the following details for the authorising contact / license holder at your organisation"
          />
        </Note>

        {showTitle && <div className="row">
          <div className="col-xs-12 col-xs-6 col-md-4">
            <Select
              label="Title"
              name="title"
              options={get(codeLists, 'titles.list')}
              intlKey="label.title"
            />
          </div>
        </div>}

        <div className="row">
          <div className="col-xs-12 col-md-4">
            <Input
              name="firstName"
              label="First Name"
              intlKey="label.first_name"
            />
          </div>

          {showMiddleName && <div className="col-xs-12 col-md-4">
            <Input
              name="middleName"
              label="Middle Name (optional)"
              intlKey="label.middle_name"
            />
          </div>}

          <div className="col-xs-12 col-md-4">
            <Input
              name="lastName"
              label="Last Name"
              intlKey="label.last_name"
            />
          </div>
        </div>

        {showRole && <div className="row">
          <div className="col-xs-12 col-xs-6 col-md-4">
            <Input
              name="role"
              label="Role in Organisation"
              intlKey="label.role_in_organisation"
            />
          </div>
        </div>}

        <div className="row">
          <div className="col-xs-12">
            <Contact
              prefix={licenseHolderAsCoordinator ? "awardLeaderRegistration" : null}
              phoneTypes={get(codeLists, 'phoneTypes.list')}
              selectedCountryIcoCode={selectedCountryIcoCode}
              showPhoneNumber={showPhone}
            />
          </div>
        </div>

        {licenseHolderAsCoordinator && <div className="row">
          <div className="col-xs-12">
            <Title h2>
              <FormattedMessage
                id="moduleTitle.personal_details"
                defaultMessage="Personal Details"
              />
            </Title>
            <PersonalDetails
              prefix="awardLeaderRegistration"
              titles={get(codeLists, 'titles.list')}
              genders={showGender && get(codeLists, 'genders.list')}
              errors={errors}
              licenseHolderAsCoordinator
              minAgeCfg={minAgeCfg}
              showDateOfBirth={showDateOfBirth}
              showMiddleName={showMiddleName}
              showTitle={showTitle}
              isOrganizationContact
            />
          </div>
        </div>}

        {licenseHolderAsCoordinator && <div className="row">
          <div className="col-xs-12">
        <Title h2>
          <FormattedMessage
            id="moduleTitle.address_details"
            defaultMessage="Address Details"
          />
        </Title>
        <Address
          prefix="awardLeaderRegistration"
          countries={showCountry && common.countries.list}
          showFirstLine={showFirstLine}
          showSecondLine={showSecondLine}
          showCity={showCity}
          showZipCode={showZipCode}
          showRegion={showRegion}
        />
         </div>
        </div>}

        {authContactAsMainCoordinatorIsEnabled && <Checkbox
          name="licenseHolderAsCoordinator"
          intlKey="label.same_as_main_coordinator"
          label="same as Main Award Coordinator"
          onChange={value => this.handleChangeSetAsMainCoordinator(value)}
        />}

        <FormDebug values={values} errors={errors} />

        <div>
          <Button type="submit">
            <FormattedMessage id="button.continue" defaultMessage="Continue" />
          </Button>
        </div>
      </form>
    )
  }
}

export default AwardUnitAuthorisingContact
